import { markRaw } from 'vue';
import WidgetEoruGe from '@/views/e-grid/eosrc-card/widgets/widget-eoru-ge.vue';
import WidgetEotransGe from '@/views/e-grid/eosrc-card/widgets/widget-eotrans-ge.vue';
import WidgetEofiderGe from '@/views/e-grid/eosrc-card/widgets/widget-eofider-ge.vue';
import WidgetEoschemaTle from '@/views/e-grid/eosrc-card/widgets/widget-eoschema-tle.vue';
import WidgetEoschemaFullTnl from '@/views/e-grid/eosrc-card/widgets/widget-eoschema-full-tnl.vue';

const list = [
    {
        name: 'Распределительные устройства',
        caption: ['kindname', 'dnum'],
        icon: '/infoenergo/assets/widget_eosrc_eoru.svg',
        component: WidgetEoruGe,
    },
    {
        name: 'Силовые трансформаторы',
        caption: ['kindname', 'dnum'],
        icon: '/infoenergo/assets/widget_eosrc_eotrans.svg',
        component: WidgetEotransGe,
    },
    {
        name: 'Присоединения',
        caption: ['kindname', 'dnum'],
        icon: '/infoenergo/assets/widget_eosrc_eofider.svg',
        component: WidgetEofiderGe,
    },
    {
        name: 'Схема энергообъекта',
        caption: ['kindname', 'dnum'],
        icon: '/infoenergo/assets/widget_eosrc_eoschema.svg',
        component: WidgetEoschemaTle,
    },
    {
        name: 'Распределительная сеть',
        caption: ['kindname', 'dnum'],
        icon: '/infoenergo/assets/widget_eosrc_eoschema_full.svg',
        component: WidgetEoschemaFullTnl,
    },
];
const useEosrcWidgetList = () => {
    return list.map(widget => {
        const { component, ...rest } = widget;
        return {
            ...rest,
            id: 'widget-' + Math.floor(Math.random() * Date.now()).toString(),
            visible: false,
            component: markRaw(component),
        };
    });
};

export default useEosrcWidgetList;
